export default __webpack_public_path__ + "static/media/USAexchangeVisitor.2cc29c05.jpg";